var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "9b8dae5bef46f9c06b29bbee7c538ecdfed3b98a"
};